export default "__VITE_ASSET__BQHZ1SCH__"